
import { getCroppedImageUrl } from "~/common/helpers";
import { mapGetters } from "vuex";

export default {
  props: {
    profiles: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters({ discreetMode: "getDiscreetStatus" }),
  },

  methods: {
    profilePhoto(profile) {
      return `url(${getCroppedImageUrl(
        profile.photo,
        "120x120",
        this.discreetMode
      )})`;
    },
  },
};
